import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as formationsService from './formations.service';

export const loadFormations = createAsyncThunk('formations/load', async ({ userId, formationId }) =>
  formationsService.getAllFormations(userId, formationId)
);

export const formationsSlice = createSlice({
  name: 'formations',
  initialState: {
    formationsTab: [],
    isLoadingFormation: false,
    isFormationsTabLoaded: false,
    error: '',
  },
  reducers: {
    initformations: (state, action) => {
      state.formationsTab = [...action.payload];
    },
    resetData: (state) => {
    state.formationsTab=[];
    state.isLoadingFormation=false;
    state.isFormationsTabLoaded=false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadFormations.pending, (state) => {
        state.isLoadingFormation = true;
        state.isFormationsTabLoaded = false;
      })
      .addCase(loadFormations.fulfilled, (state, action) => {
        state.isLoadingFormation = false;
        state.isFormationsTabLoaded = true;
        // console.log('liste de formations recuperer avec success depuis le reducer:', [
        //   action.payload.data,
        // ]);
        state.formationsTab = [...action.payload.data];
      })
      .addCase(loadFormations.rejected, (state, action) => {
        state.isLoadingFormation = false;
        state.isFormationsTabLoaded = true;
        state.error = action?.payload?.data ? action.payload.message : action.error.message;
      });
  },
});

export const { initFormations,resetData } = formationsSlice.actions;
export default formationsSlice.reducer;
